import React from 'react';

interface ProgressBarProps {
  currentStep: number;
  totalSteps?: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep, totalSteps = 7 }) => {
  const steps = [
    { name: '身分', path: '/start' },
    { name: '交通', path: '/transport' },
    { name: '住宿', path: '/stay' },
    { name: '工作', path: '/workspace' },
    { name: '社群', path: '/community' },
    { name: '文化', path: '/culture-experience' },
    { name: '完成', path: '/summary' },
  ];

  // 計算進度百分比，確保不會超過100%
  const progressPercentage = Math.min((currentStep / steps.length) * 100, 100);

  return (
    <div className="w-full bg-white shadow-soft rounded-2xl p-6 mb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-800">預約流程</h2>
        <span className="text-sm text-gray-500">
          步驟 {currentStep} / {steps.length}
        </span>
      </div>
      
      <div className="relative">
        {/* 進度條背景 */}
        <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-200 rounded-full transform -translate-y-1/2"></div>
        
        {/* 進度條填充 */}
        <div 
          className="absolute top-1/2 left-0 h-1 bg-gradient-to-r from-hualien-blue to-blue-500 rounded-full transform -translate-y-1/2 transition-all duration-500 ease-out"
          style={{ width: `${progressPercentage}%` }}
        ></div>
        
        {/* 步驟點 */}
        <div className="relative flex justify-between">
          {steps.map((step, index) => {
            const isActive = index + 1 <= currentStep;
            const isCurrent = index + 1 === currentStep;
            
            return (
              <div key={index} className="flex flex-col items-center">
                <div 
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 ${
                    isActive 
                      ? 'bg-gradient-to-r from-hualien-blue to-blue-500 text-white shadow-medium' 
                      : 'bg-gray-200 text-gray-500'
                  } ${isCurrent ? 'ring-4 ring-blue-200 scale-110' : ''}`}
                >
                  {isActive ? '✓' : index + 1}
                </div>
                <span className={`text-xs mt-2 font-medium transition-colors duration-300 ${
                  isActive ? 'text-hualien-blue' : 'text-gray-400'
                }`}>
                  {step.name}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar; 